
<div class="row">
   <div class="col-md-3 col-sm-3 col-12 col-lg-3" >
      <div class="row">
         <div class="col-12 col-12 text-center head-farms center-block">
            <span class="mt-4"></span>
         </div>
         <div class="col-12 center-block">
            <app-filter-farms [params]="myForm" [isCreated]=false ></app-filter-farms>
            <button (click)="onSubmit()" class=" float-xl-right mt-2 mb-2" mat-raised-button color="primary">{{ 'FARM.SEARCH_FARM' | translate }}</button>
         </div> 
      </div>
   </div>

   <div class="col-md-9 col-sm-9 col-12 col-lg-9" >
      <div class="row">
         <div class="col-12 text-center head-farms center-block" *ngIf="numberFarms>0">
            <strong><span class="mt-2">{{numberFarms}} {{ 'FARM.FARMS_FOUNDED' | translate }} </span></strong>
         </div>
         <div class="col-12 text-center head-farms " *ngIf="numberFarms==0">
            <strong><span class="mt-2">{{ 'FARM.NOT_FOUND' | translate }} </span></strong>
         </div>
         <div class="col-md-12 col-sm-12 col-12 col-lg-12">
            <mat-card >
               <app-map-farms class="mr-2" [allFarms]="allFarms" ></app-map-farms>  
            </mat-card>   
         </div>
      </div>	
   </div>
</div>